import PuppyInfoOk from '../action-types/listingPuppyInfoOk';

const initialState = true;

const PuppyInfoOkReducer = (state = initialState, action) => {
  switch (action.type) {
    case PuppyInfoOk.SET_PUPPY_INFO_OK: {
      const { infoIsOk } = action;
      return infoIsOk;
    }
    default:
      return state;
  }
};

export default PuppyInfoOkReducer;
